import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollManager from "@/components/site/ScrollManager";
import SmoothScroll from "@/components/site/SmoothScroll";
import Home from "@/pages/Home"; // Home is eagerly loaded (primary landing)

// Supporting pages are lazily loaded so the landing page's initial JS
// payload stays as small as possible.
const Listings = lazy(() => import("@/pages/Listings"));
const Faq = lazy(() => import("@/pages/Faq"));
const Contact = lazy(() => import("@/pages/Contact"));
const About = lazy(() => import("@/pages/About"));
const Insights = lazy(() => import("@/pages/Insights"));
const Article = lazy(() => import("@/pages/Article"));
const Admin = lazy(() => import("@/pages/Admin"));
const DealerBrief = lazy(() => import("@/pages/DealerBrief"));
const RegionalLanding = lazy(() => import("@/pages/RegionalLanding"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="grid min-h-[60vh] place-items-center bg-white text-black/40"
    >
      <div className="flex items-center gap-3">
        <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-[#4F0DFF]" />
        <span className="text-sm">Loading…</span>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <SmoothScroll>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sample-listings" element={<Listings />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/request-a-visit" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<Article />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/dealer-brief" element={<DealerBrief />} />
            <Route path="/dealerships/:city" element={<RegionalLanding />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </SmoothScroll>
      <Toaster position="bottom-right" richColors closeButton />
    </BrowserRouter>
  );
}
